import React from "react";
import "../../styles/AboutHero.css";

import creator from "../../assets/creator3.webp";
import learn from "../../assets/learn.png";
import create from "../../assets/create.png";
import grow from "../../assets/grow.png";
import earn from "../../assets/earn.png";
import dots from "../../assets/dots.png";
import play from "../../assets/play.png";

export default function AboutHero() {
  return (
    <section className="about-us-hero-section">
      
      <img
        src={dots}
        alt=""
        className="about-us-hero-dots about-us-hero-dots-left"
      />
      <img
        src={dots}
        alt=""
        className="about-us-hero-dots about-us-hero-dots-right"
      />

      <div className="about-us-hero-container">
        
        <div className="about-us-hero-left-block">
          <span className="about-us-hero-overline">ABOUT CREATORS DOST</span>
          
          <h1 className="about-us-hero-main-title">
            Empowering Creators.
            <br />
            <span>Building Futures.</span>
          </h1>
          
          <div className="about-us-hero-gold-line"></div>
          
          <p className="about-us-hero-description">
            Creators Dost is India's most trusted creator learning platform on a
            mission to empower the next generation of creators with the right
            skills, mentorship, community and opportunities to build a
            sustainable and impactful creator career.
          </p>
          
          <div className="about-us-hero-buttons-row">
            <button className="about-us-hero-primary-btn">
              Explore Courses <span>→</span>
            </button>
            
          </div>

          
          <div className="about-us-hero-stats-row">
            <div className="about-us-hero-stat-node">
              <div className="about-us-hero-stat-number">
                👥 <strong>4.7K+</strong>
              </div>
              <span>Happy Learners</span>
            </div>
            
            <div className="about-us-hero-stat-divider" />
            
            <div className="about-us-hero-stat-node">
              <div className="about-us-hero-stat-number">
                🎓 <strong>10M+</strong>
              </div>
              <span>Subscribers</span>
            </div>
            
            <div className="about-us-hero-stat-divider" />
            
            <div className="about-us-hero-stat-node">
              <div className="about-us-hero-stat-number">
                📚 <strong>2B+</strong>
              </div>
              <span>Views Generated</span>
            </div>
            
            <div className="about-us-hero-stat-divider" />
            
            <div className="about-us-hero-stat-node">
              <div className="about-us-hero-stat-number">
                ⭐ <strong>4.9/5</strong>
              </div>
              <span>Average Rating</span>
            </div>
          </div>
        </div>

        
        <div className="about-us-hero-right-block">
          
          <div className="about-us-hero-blue-glow"></div>

          
          <div className="about-us-hero-orange-circle"></div>

         
          <img
            src={creator}
            alt="Creator Dost"
            className="about-page-hero-main-creator-img"
          />

          
          <div className="about-us-hero-floating-card about-us-hero-card-grow">
            <img src={grow} alt="Grow Asset" />
            <div>
              <h4>Grow</h4>
              <p>Scale your audience</p>
            </div>
          </div>

         
          <div className="about-us-hero-floating-card about-us-hero-card-create">
            <img src={create} alt="Create Asset" />
            <div>
              <h4>Create</h4>
              <p>Bring your ideas to life</p>
            </div>
          </div>

          
          <div className="about-us-hero-floating-card about-us-hero-card-learn">
            <img src={learn} alt="Learn Asset" />
            <div>
              <h4>Learn</h4>
              <p>Industry relevant courses</p>
            </div>
          </div>

          
          <div className="about-us-hero-floating-card about-us-hero-card-earn">
            <img src={earn} alt="Earn Asset" />
            <div>
              <h4>Earn</h4>
              <p>Turn passion into income</p>
            </div>
          </div>

          
          <img
            src={play}
            alt="Play Trigger"
            className="about-us-hero-play-btn"
          />
        </div>

      </div>
    </section>
  );
}